import { getNavi, getPage, getHours, getFront, getMenus, getContact, getPost, getBlog, getBlogs, getReservationTexts } from '../api/contentfulAPI';
import { getDate } from '../api/dateAPI';
import { getProductsInCollection } from '../api/shopifyAPI';

export const RECEIVE_NAVI = 'RECEIVE_NAVI';
export const RECEIVE_PAGES = 'RECEIVE_PAGES';
export const RECEIVE_DATE = 'RECEIVE_DATE';
export const RECEIVE_HOURS = 'RECEIVE_HOURS';
export const RECEIVE_RESERVATION_INFO = 'RECEIVE_RESERVATION_INFO';
export const SWITCH_LANG = 'SWITCH_LANG';
export const ADD_COUNT = 'ADD_COUNT';
export const SET_MODAL_NEWSLETTER = 'SET_MODAL_NEWSLETTER';
export const RECEIVE_FRONTPAGE = 'RECEIVE_FRONTPAGE';
export const RECEIVE_INSTAGRAM = 'RECEIVE_INSTAGRAM';
export const RECEIVE_MENUS = 'RECEIVE_MENUS';
export const RECEIVE_CONTACT = 'RECEIVE_CONTACT';
export const RECEIVE_BLOGS = 'RECEIVE_BLOGS';
export const RECEIVE_BLOG = 'RECEIVE_BLOG';
export const RECEIVE_POST = 'RECEIVE_POST';
export const RESET_POST = 'RESET_POST';
export const RECEIVE_COLLECTIONS = 'RECEIVE_COLLECTIONS';

const isFetching = {};

// filter item by time
const isItemValid = (item, time) => {
  return (!item.fields.validFrom || new Date(time) >= new Date(item.fields.validFrom))
    && (!item.fields.validUntil || new Date(time) < new Date(item.fields.validUntil));
}

export const fetchNavi = (locale) => (dispatch, state) => {
  const FLAG = 'fetchNavi';
  if (!isFetching[FLAG]) {
    isFetching[FLAG] = true;
    return getNavi(locale).then(items => {
      isFetching[FLAG] = false;
      dispatch(receiveNavi(items))
    });
  }
};

const receiveNavi = (items) => ({
  type: RECEIVE_NAVI,
  items: items.map(item => {
    return {...item.fields};
  }),
});

export const fetchPage = (slug, locale) => (dispatch) => {
  const FLAG = `fetchPage_${slug}`;
  if (!isFetching[FLAG]) {
    isFetching[FLAG] = true;
    return getPage(slug, locale).then(item => {
      isFetching[FLAG] = false;
      dispatch(receivePage(item))
    });
  }
}

const receivePage = (item) => {
  return {
    type: RECEIVE_PAGES,
    item
  }
}

// fetch and get the front page head
export const fetchFront = (locale, time) => (dispatch) => {
  const FLAG = 'fetchFront';
  if (!isFetching[FLAG]) {
    isFetching[FLAG] = true;
    return getFront(locale).then(item => {
      isFetching[FLAG] = false;
      dispatch(receiveFront(item, time));
    })
  }
}

const receiveFront = (data, time) => {
  return {
    type: RECEIVE_FRONTPAGE,
    data: {
      header:data.header,
      containers:data.containers?data.containers.filter(lift => isItemValid(lift, time)):null
    }
  }
}


export const fetchDate = () => (dispatch) => {
  const FLAG = 'fetchDate';
  if (!isFetching[FLAG]) {
    isFetching[FLAG] = true;
    return getDate().then(date => {
      isFetching[FLAG] = false;
      dispatch(receiveDate(date))
    })
  }
};

const receiveDate = (date) => ({
  type: RECEIVE_DATE,
  date,
});


export const fetchReservationTexts = (locale) => (dispatch) => {
  const FLAG = 'fetchReservationTexts';
  if (!isFetching[FLAG]) {
    isFetching[FLAG] = true;
    return getReservationTexts(locale).then(texts => {
      isFetching[FLAG] = false;
      dispatch(receiveReservationTexts(texts))
    })
  }
}

const receiveReservationTexts = (texts) => ({
  type: RECEIVE_RESERVATION_INFO,
  texts
})

// fetch and receive the open hours text
export const fetchHours = (locale) => (dispatch) => {
  const FLAG = 'fetchHours';
  if (!isFetching[FLAG]) {
    isFetching[FLAG] = true;
    return getHours(locale).then(text => {
      isFetching[FLAG] = false;
      dispatch(receiveHours(text))
    })
  }
}

const receiveHours = (hoursText) => ({
  type: RECEIVE_HOURS,
  hoursText
})

export const switchLang = () => ({
  type: SWITCH_LANG
});

// Create action to increment page count
export const addCount = () => ({
  type: ADD_COUNT,
});

// Create action to set modal newsletter visility
export const setModalNewsLetter = (f) => (dispatch) => {
  const FLAG = 'setModalNewsLetter';
  if (isFetching[FLAG]) {
    return;
  }

  if (f !== 'visible') {
    // Take down immediately
    dispatch({
      type: SET_MODAL_NEWSLETTER,
      visible: f,
    });
  }

  // Show newsletter after a little delay
  isFetching[FLAG] = true;
  window.setTimeout(() => {
    isFetching[FLAG] = false;
    dispatch({
      type: SET_MODAL_NEWSLETTER,
      visible: f,
    });
  }, 5000);
};

// fetch and receive instagram
/*export const fetchInstagram = () => (dispatch) => {
  const FLAG = "fetchInstagram";
  isFetching[FLAG] = true;
  
  const site_name = process.env.REACT_APP_INSTAGRAM_SITE_NAME;
  var today = new Date();

  const timestamp = today.getFullYear() + "" + (today.getMonth() +1) + "" + today.getDate() + "" + today.getHours();
  return fetch(`https://instagram.monkfish.fi/cache/${site_name}.json?c=${timestamp}`)
    .then(x=>{
      return x.json()
    })
    .then(y=>{
      dispatch(receiveInstagram(y.data));
    })
}*/
/*export const fetchInstagram = () => (dispatch) => {
  const FLAG = "fetchInstagram";
  isFetching[FLAG] = true;
  const commentsParam = '';
  const instagram_id = process.env.REACT_APP_INSTAGRAM_ID;
  const access_token = process.env.REACT_APP_INSTAGRAM_TOKEN;
  
  return fetch(`https://graph.facebook.com/v7.0/${instagram_id}/media?fields=media_url,thumbnail_url,caption,media_type,like_count,shortcode,timestamp,comments_count,username,children{media_url},permalink${commentsParam}&limit=2&access_token=${access_token}`)
    .then(x=>{
      return x.json()
    })
    .then(y=>{
      dispatch(receiveInstagram(y.data));
    })
}*/
/*
const receiveInstagram = (data) => {
  const FLAG = "fetchInstagram";
  isFetching[FLAG] = false;
  return {
    type: RECEIVE_INSTAGRAM,
    data
  };
}
*/
// fetch and receive menu data
export const fetchMenu = (time, locale) => (dispatch) => {
  const FLAG = "fetchMenu";
  if (!isFetching[FLAG]) {
    isFetching[FLAG] = true;
    return getMenus(locale).then(data =>
      dispatch(receiveMenus(data, time))
    )
  }
}

const receiveMenus = (menus, time) => {
  const FLAG = "fetchMenu";
  isFetching[FLAG] = false;
  return {
    type: RECEIVE_MENUS,
    data: menus.filter(menu => isItemValid(menu, time))
  };
}

// fetch and receive the contact page content
export const fetchContact = (locale) => (dispatch) => {
  const FLAG = 'fetchContact';
  if (!isFetching[FLAG]) {
    isFetching[FLAG] = true;
    return getContact(locale).then(data => {
      isFetching[FLAG] = false;
      dispatch(receiveContact(data))
    })
  }
}

const receiveContact = (data) => {
  return {
    type: RECEIVE_CONTACT,
    data
  }
}

// Clear blog post
export const resetPost = () => (dispatch) => {
  const FLAG = 'fetchPost';
  if (!isFetching[FLAG]) {
    isFetching[FLAG] = true;
    return dispatch(receiveResetPost());
  }
};

const receiveResetPost = (post) => {
  const FLAG = 'fetchPost';
  isFetching[FLAG] = false;
  return {
    type: RESET_POST,
    data: null,
  };
};

// fetch and receive blog post content
export const fetchPost = (slug) => (dispatch) => {
  const FLAG = 'fetchPost';
  if (!isFetching[FLAG]) {
    isFetching[FLAG] = true;
    return getPost(slug).then(data => {
      dispatch(receivePost(data))
    });
  }
};

const receivePost = (post) => {
  const FLAG = 'fetchPost';
  isFetching[FLAG] = false;
  return {
    type: RECEIVE_POST,
    data: post,
  };
};

// fetch and receive blog page content
export const fetchBlog = (locale) => (dispatch) => {
  const FLAG = 'fetchBlog';
  if (!isFetching[FLAG]) {
    isFetching[FLAG] = true;
    return getBlog(locale).then(data => {
      dispatch(receiveBlog(data))
    });
  }
};

const receiveBlog = (blog) => {
  const FLAG = 'fetchBlog';
  isFetching[FLAG] = false;
  return {
    type: RECEIVE_BLOG,
    data: blog,
  };
};

// fetch and receive blog pages
export const fetchBlogs = (locale, limit, offset) => (dispatch) => {
  const FLAG = 'fetchBlogs';
  if (!isFetching[FLAG]) {
    isFetching[FLAG] = true;
    return getBlogs(locale, limit, offset).then(data => {
      dispatch(receiveBlogs(data))
    });
  }
};

const receiveBlogs = (blogs) => {
  const FLAG = 'fetchBlogs';
  isFetching[FLAG] = false;
  return {
    type: RECEIVE_BLOGS,
    data: blogs
  };
};

export const fetchCollection = (id) => (dispatch) => {
  const FLAG = 'fetchGiftCard';
  if (!isFetching[FLAG]) {
    isFetching[FLAG] = true;
    return getProductsInCollection(id).then(collection => {
      isFetching[FLAG] = false;
      dispatch(receiveCollection(collection))
    });
  }
};

const receiveCollection = (collection) => ({
  type: RECEIVE_COLLECTIONS,
  collection
});



// WEBPACK FOOTER //
// ./src/redux/actions.js